import { takeEvery, all, call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import moment from 'moment';
import apiService from 'app/bff/services/apiService';
import { AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { MbRegisterReq, MbRegisterResp } from 'app/bff/models/mb/mbRegister';
import { ROUTES } from 'app/core/router/paths';
import { ProcessRouteMatchesStep } from 'app/features/Member/Register/General/types';
import { sagaBoundary } from 'app/store/service';
import { MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP, MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP, MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP, MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP, MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP, MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA, SendMobileOTPAction, ResendMobileOTPAction, AuthMobileOTPAction, SendEmailOTPAction, AuthEmailOTPAction, SendRegisterDataAction } from './types';
import { setAccessibleStepAction, sendMobileOTPDoneAction, resendMobileOTPDoneAction, sendEmailOTPAction, sendEmailOTPDoneAction, sendRegisterDataAction, sendRegisterDataDoneAction } from './actions';

/**
 * @description 發送手機 OTP 驗證碼
 */
function * sendMobileOTP (action: SendMobileOTPAction) {
  const response: AaOtpSendcodeResp = yield call(apiService.postAaOtpSendcode, action.payload.args);
  if (response) {
    // 緩存 OTP 資料
    yield put(sendMobileOTPDoneAction(response));
    // 將「確認資料」(Step-3-2) 設為可訪問步驟
    yield put(setAccessibleStepAction(ProcessRouteMatchesStep[ROUTES.MEMBER__REGISTER__GENERAL__CONFIRM_INFO__OTP_AUTH]));
    // 導頁至「確認資料」(Step-3-2)
    yield put(push(ROUTES.MEMBER__REGISTER__GENERAL__CONFIRM_INFO__OTP_AUTH));
  }
}

/**
 * @description 重新發送手機 OTP 驗證碼
 */
function * resendMobileOTP (action: ResendMobileOTPAction) {
  const response: AaOtpSendcodeResp = yield call(apiService.postAaOtpSendcode, action.payload.args);
  if (response) {
    // 更新 OTP 資料
    yield put(resendMobileOTPDoneAction(response));
  }
}

/**
 * @description 驗證手機 OTP 驗證碼
 */
function * authMobileOTP (action: AuthMobileOTPAction) {
  const response: AaOtpVerifyResp = yield call(apiService.postAaOtpVerify, action.payload.authMobileOTPArgs);
  if (response) {
    // 發送信箱 OTP 驗證碼
    yield put(sendEmailOTPAction(action.payload.sendEmailOTPArgs));
  }
}

/**
 * @description 發送信箱 OTP 驗證碼
 */
function * sendEmailOTP (action: SendEmailOTPAction) {
  const response: AaOtpSendcodeResp = yield call(apiService.postAaOtpSendcode, action.payload.args);
  if (response) {
    // 緩存 OTP 資料
    yield put(sendEmailOTPDoneAction(response));
  }
}

/**
 * @description 驗證信箱 OTP 驗證碼
 */
function * authEmailOTP (action: AuthEmailOTPAction) {
  const response: AaOtpVerifyResp = yield call(apiService.postAaOtpVerify, action.payload.authEmailOTPArgs);
  if (response) {
    // 送出會員資料執行註冊
    const args: MbRegisterReq = { ...action.payload.registerArgs, regOtpTime: moment().format('YYYY-MM-DD HH:mm:ss') };
    yield put(sendRegisterDataAction(args));
  }
}

/**
 * @description 送出會員資料執行註冊
 */
function * sendRegisterData (action: SendRegisterDataAction) {
  const response: MbRegisterResp = yield call(apiService.postMbRegister, action.payload.args);
  if (response) yield put(sendRegisterDataDoneAction(response));
}

export default function * watchGeneralSaga () {
  yield all([
    takeEvery(MEMBER_REGISTER_GENERAL__SEND_MOBILE_OTP, sagaBoundary(sendMobileOTP)),
    takeEvery(MEMBER_REGISTER_GENERAL__RESEND_MOBILE_OTP, sagaBoundary(resendMobileOTP)),
    takeEvery(MEMBER_REGISTER_GENERAL__AUTH_MOBILE_OTP, sagaBoundary(authMobileOTP)),
    takeEvery(MEMBER_REGISTER_GENERAL__SEND_EMAIL_OTP, sagaBoundary(sendEmailOTP)),
    takeEvery(MEMBER_REGISTER_GENERAL__AUTH_EMAIL_OTP, sagaBoundary(authEmailOTP)),
    takeEvery(MEMBER_REGISTER_GENERAL__SEND_REGISTER_DATA, sagaBoundary(sendRegisterData))
  ]);
}
